import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';

import { TFunction } from '../translate';

dayjs.extend(localeData);
dayjs.extend(localizedFormat);

const SHORT_DATE_MAPPING: { [key: string]: string } = {
  'MM/DD/YYYY': 'MM/DD',
  'DD/MM/YYYY': 'DD/MM',
  'D/‏M/‏YYYY': 'D/M',
  'DD.MM.YYYY': 'DD.MM',
  'D.MM.YYYY': 'D.MM',
  'DD-MM-YYYY': 'DD-MM',
  'D/M/YYYY': 'D/M',
  'YYYY-MM-DD': 'MM-DD',
  'MM/D/YYYY': 'MM/D',
  'YYYY.MM.DD.': 'MM.DD.',
  'YYYY/MM/DD': 'MM/DD',
  'DD.MM.YYYY.': 'DD.MM.',
  'DD. MM. YYYY': 'DD. MM.',
  // Custom pseudo
  DD_MM_YYYY: 'DD_MM',
};

export const getDateShortWithoutYearFormat = () =>
  SHORT_DATE_MAPPING[dayjs.localeData().longDateFormat('L')] || 'DD/MM';

// Allow translating the date format
// The date format is localised, but still uses D for Day, M for month
// Translating this allows the format itself to be translated
// These translations are in a different namespace (dateFormat)
export const getUserFormatDateWithoutYear = (t: TFunction<string>) =>
  t('dateFormat:' + getDateShortWithoutYearFormat(), { nsSeparator: ':' });

const MEDIUM_DATE_MAPPING: { [key: string]: string } = {
  'D MMM YYYY': 'D MMM',
  'MMM D, YYYY': 'MMM D',
  'D. MMM YYYY': 'D. MMM',
  'YYYY MMM D': 'MMM D',
  '~D ~MMM ~YYYY': '~D ~MMM',
};

export const getDateMediumWithoutYearFormat = () =>
  MEDIUM_DATE_MAPPING[dayjs.localeData().longDateFormat('ll')] || 'D MMM';
